import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import MuiAlert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import { FloatingAlert } from './internal/FloatingAlert';
import { FullWidthAlert } from './internal/FullWidthAlert';
import { FULL_WIDTH_SIDE_PADDING } from './alert.consts';
import { jsx as _jsx } from "react/jsx-runtime";
export function Alert(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? 'default' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'floating' : _props$size;
  var theme = useTheme();
  var severity = 'info';
  switch (color) {
    case 'error':
      severity = 'error';
      break;
    case 'warning':
      severity = 'warning';
      break;
    case 'success':
      severity = 'success';
      break;
  }
  var _useState = useState("".concat(theme.spacing(4), " ").concat(FULL_WIDTH_SIDE_PADDING, "px")),
    _useState2 = _slicedToArray(_useState, 2),
    fullWidthPadding = _useState2[0],
    setFullWidthPadding = _useState2[1];
  var handleFullWidthPaddingChange = function handleFullWidthPaddingChange(isMobile) {
    if (isMobile) {
      setFullWidthPadding(theme.spacing(4));
    } else {
      setFullWidthPadding("".concat(theme.spacing(4), " ").concat(FULL_WIDTH_SIDE_PADDING, "px"));
    }
  };
  return size === 'floating' ? /*#__PURE__*/_jsx(MuiAlert, _extends({
    icon: false
  }, (color === 'default' || color === 'gray') && {
    color: color === 'default' ? 'info' : 'warning'
  }, {
    severity: severity,
    sx: {
      '.MuiAlert-icon': {
        padding: 0
      },
      '.MuiAlert-message': {
        padding: 0,
        width: '100%'
      },
      alignItems: 'start',
      maxWidth: '100%',
      padding: theme.spacing(4),
      position: 'relative'
    },
    variant: 'filled',
    children: /*#__PURE__*/_jsx(FloatingAlert, _extends({}, props))
  })) : /*#__PURE__*/_jsx(MuiAlert, _extends({
    icon: false
  }, (color === 'default' || color === 'gray') && {
    color: color === 'default' ? 'info' : 'warning'
  }, {
    severity: severity,
    sx: {
      '.MuiAlert-icon': {
        padding: '6px'
      },
      '.MuiAlert-message': {
        padding: 0,
        width: '100%'
      },
      alignItems: 'center',
      padding: fullWidthPadding,
      position: 'relative'
    },
    variant: "outlined",
    children: /*#__PURE__*/_jsx(FullWidthAlert, _extends({
      handleFullWidthPaddingChange: handleFullWidthPaddingChange
    }, props))
  }));
}